import {ServiceOrderStatus} from "./ServiceOrderStatus";

export const ServiceOrderStatusNames: Record<ServiceOrderStatus, string> = {
  [ServiceOrderStatus.IN_PROGRESS]: "En Progreso",
  [ServiceOrderStatus.DEFINE_WORK_SCOPE]: "Definir Alcance",
  [ServiceOrderStatus.VALIDATE_WORK_SCOPE]: "Validar Alcance",
  [ServiceOrderStatus.FIX_WORK_SCOPE]: "Corregir Alcance",
  [ServiceOrderStatus.SENT]: "Enviada",
  [ServiceOrderStatus.CONFIRM]: "Confirmada",
  [ServiceOrderStatus.COMPLETED]: "Completada",
  [ServiceOrderStatus.TO_FIX]: "A corregir",
  [ServiceOrderStatus.CLOSED]: "Cerrada",
  [ServiceOrderStatus.UNDER_EVALUATION]: "En Evaluacion",
};
